// this file contains collections of all utility functions

export const current_url = new URL(window.location.href.split('?')[0]);
/**
 *  Returns params from the current url
 * @type {module:url.URLSearchParams}
 */
const params = new Proxy(new URLSearchParams(window.location.search), {
	get: (searchParams, prop) => searchParams.get(prop),
	set: (searchParams, prop, value) =>
		modifyQueryParams(searchParams, prop, value),
});

function modifyQueryParams(target, prop, value) {
	target[prop] = value;
	target.set(prop, value);

	try {
		window.history.pushState({}, '', '?' + target);
		return true;
	} catch (e) {
		console.error(e);
		return true;
	}
}

const click_alert = (selector, message) => {
	const alert = (e) => {
		if (!confirm(message)) {
			e.preventDefault();
		}
	};

	document.querySelectorAll(selector).forEach((el) => {
		el.onclick = alert;
	});
};

const change_alert = (selector, message, val = '') => {
	const alert = (e) => {
		const run = e.target.value === val;
		if (run && !confirm(message)) {
			e.preventDefault();
		}
	};

	document.querySelectorAll(selector).forEach((el) => {
		el.onchange = alert;
	});
};

/**
 * Checks whether the current device is desktop or not
 * @returns boolen
 */
function isDesktopDevice() {
	return window.matchMedia('only screen and (min-width: 992px)').matches;
}

/**
 * Check whether the current device is big screen or not - 1200px
 * @returns boolen
 */
function isBigScreenDevice() {
	return window.matchMedia('only screen and (min-width: 1200px)').matches;
}

function isTabletDevice() {
	return window.matchMedia(
		'only screen and (min-width: 768px) and (max-width:991px)',
	).matches;
}

function isMobileDevice() {
	return window.matchMedia('only screen and (max-width: 767px)').matches;
}

/**
 * Reusable component for scrolling logic
 * @param {HTMLElement} element - Element to which section you need to scroll
 * @param {string} block - start, center, end, or nearest. Defaults to start
 * @returns void
 */
function scrollIntoView(element, block) {
	try {
		if (!element) return;

		element.scrollIntoView({
			behavior: 'smooth',
			block: block,
			inline: 'nearest',
		});
	} catch (e) {
		console.error(e);
	}
}
/**
 * Reusable component for debouncing
 * @param { function } func
 * @param { number } delay
 */
function debounce(func, delay) {
	let timeoutId;
	return function (...args) {
		clearTimeout(timeoutId);
		timeoutId = setTimeout(() => {
			func(...args);
		}, delay);
	};
}

/**
 * Reusable component for throttling
 * @param { function } func
 * @param { number } limit
 */
function throttle(func, limit) {
	let inThrottle;
	return function (...args) {
		if (!inThrottle) {
			func(...args);
			inThrottle = true;
			setTimeout(() => {
				inThrottle = false;
			}, limit);
		}
	};
}

/**
 * Updates a specific query parameter in the current URL without modifying the window URL.
 *
 * This function modifies the specified query parameter and returns the new URL
 * as a string. It does not update the URL in the browser's address bar.
 *
 * @param {string} param - The name of the query parameter to update.
 * @param {string} value - The new value for the query parameter.
 * @returns {string} - The updated URL with the modified query parameter.
 */
const updateParamFromUrlString = (param, value) => {
	// Get the current URL
	const currentUrl = window.location.href;

	// Create a URL object
	const url = new URL(currentUrl);

	// Get the URLSearchParams object
	const params = url.searchParams;

	// Modify the specific query parameter
	params.set(param, value);

	// Update the URL object with the new query parameters
	url.search = params.toString();

	// Convert the URL object back to a string and return it
	return url.toString();
};

export {
	params,
	click_alert,
	change_alert,
	scrollIntoView,
	isDesktopDevice,
	isMobileDevice,
	isTabletDevice,
	isBigScreenDevice,
	debounce,
	throttle,
	updateParamFromUrlString
};
